import { Disclosure } from "@headlessui/react";

import Editorials from "~/types/editorials";
import contentfulUtils from "~/utils/contentful-utils";
import { isActiveEntry } from "~/utils/editorial-utils";

import HighlightedText from "../common/highlighted-text";
import Icon from "../common/icon";
import IconChevronDown from "../common/icons/icon-chevron-down";
import IconChevronUp from "../common/icons/icon-chevron-up";
import RichText from "../common/rich-text";
import styles from "./cart-accordions.module.scss";

type Props = {
  page: Editorials.CartPage | null;
};

export default function CartAccordions(props: Props) {
  return props.page ? (
    <div className={styles.container}>
      {props.page.accordions?.filter(isActiveEntry).map((element) => (
        <Disclosure as="div" key={element.sys.id} className={styles.accordion}>
          {({ open }) => (
            <>
              <Disclosure.Button className={styles.button}>
                <div className={styles.trigger}>
                  {element.fields.icon && isActiveEntry(element.fields.icon) ? (
                    <Icon
                      svgMedia={element.fields.icon.fields.svgMedia}
                      name={element.fields.icon.fields.svgIconId}
                      aria-hidden
                      width={32}
                      height={32}
                    />
                  ) : null}
                  <p
                    className={
                      contentfulUtils.isHighlightText(element.fields.title)
                        ? styles.accordionTitleHighlighted
                        : styles.accordionTitle
                    }
                  >
                    <HighlightedText text={element.fields.title} />
                  </p>
                </div>
                <Icon icon={open ? IconChevronUp : IconChevronDown} aria-hidden width={16} height={16} />
              </Disclosure.Button>
              <Disclosure.Panel static className={styles.panel}>
                <div className={styles.panelInner}>
                  <RichText text={element.fields.content} />
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  ) : null;
}
